import defaultTemplate from './default.hbs';
import onePageRegistrationSocialTemplate from './experiments/onePageRegistrationSocial.hbs';
import reskinTemplate from './reskin.hbs';

export default {
  default: defaultTemplate,
  onePageRegistrationSocial: onePageRegistrationSocialTemplate,
  reskin: reskinTemplate
};
